import React, {useState} from 'react';
import DataTable from './DataTable';
import {deleteUser, getUsers, sendUserReset, updateUser} from '../../libraries/AdminApi';

const AUTH_LABELS = {APPLE: 'Apple', EMAIL: 'Email', SPOTIFY: 'Spotify', USER_PASSWORD_AUTH: 'Email (legacy)'};
const fmt = (d) => (d ? new Date(d).toLocaleDateString(undefined, {year: 'numeric', month: 'short', day: 'numeric'}) : '—');

export default function UsersPage({me}) {
    const [notice, setNotice] = useState(null);
    const act = (promise, ok, reload) => promise
        .then(() => { setNotice(ok); reload(); })
        .catch((e) => setNotice(e.message));

    return (
        <div>
            <h1 className="font-heading text-[28px] font-bold tracking-[-0.015em]">Users</h1>
            <p className="mb-6 mt-1 text-[13px] text-white/45">Everyone with an AbTunes account.</p>
            {notice && (
                <div className="mb-4 flex items-center justify-between rounded-xl bg-white/[0.07] px-4 py-2.5 text-[13px]">
                    {notice}
                    <button type="button" onClick={() => setNotice(null)} className="text-white/40 hover:text-white"><i className="fa-solid fa-xmark"/></button>
                </div>
            )}
            <DataTable
                fetcher={getUsers}
                searchPlaceholder="Search by email…"
                filters={[
                    {key: 'is_admin', label: 'Role', options: [{value: '1', label: 'Admins'}, {value: '0', label: 'Listeners'}]},
                    {key: 'auth_type', label: 'Sign-in', options: (r) => (r?.filters?.auth_type || []).map((t) => ({value: t, label: AUTH_LABELS[t] || t}))},
                ]}
                columns={[
                    {key: 'id', label: 'ID', sortable: true, className: 'w-16 tabular-nums text-white/50'},
                    {key: 'email', label: 'Email', sortable: true, render: (u) => (
                        <span className="flex items-center gap-2">
                            {u.email}
                            {u.is_admin && <span className="rounded-full bg-apple-red/[0.15] px-2 py-0.5 text-[9.5px] font-extrabold uppercase text-apple-red">Admin</span>}
                        </span>
                    )},
                    {key: 'auth_type', label: 'Sign-in', sortable: true, render: (u) => <span className="text-white/60">{AUTH_LABELS[u.auth_type] || u.auth_type}</span>},
                    {key: 'plays_count', label: 'Plays', sortable: true, className: 'tabular-nums text-white/60'},
                    {key: 'last_active_at', label: 'Last played', sortable: true, render: (u) => <span className="text-white/60">{fmt(u.last_active_at)}</span>},
                    {key: 'created_at', label: 'Joined', sortable: true, render: (u) => <span className="text-white/60">{fmt(u.created_at)}</span>},
                ]}
                actions={(u, reload) => (
                    <span className="flex justify-end gap-1.5">
                        <button type="button" title={u.is_admin ? 'Remove admin' : 'Make admin'}
                                disabled={u.id === me?.id}
                                onClick={() => act(updateUser(u.id, {is_admin: !u.is_admin}), `${u.email} is ${u.is_admin ? 'no longer' : 'now'} an admin`, reload)}
                                className="rounded-lg bg-white/[0.07] px-2.5 py-1.5 text-[11.5px] font-semibold text-white/70 transition hover:text-white disabled:opacity-30">
                            {u.is_admin ? 'Remove admin' : 'Make admin'}
                        </button>
                        <button type="button" title="Email a password reset link"
                                onClick={() => act(sendUserReset(u.id), `Reset link sent to ${u.email}`, reload)}
                                className="rounded-lg bg-white/[0.07] px-2.5 py-1.5 text-[11.5px] font-semibold text-white/70 transition hover:text-white">
                            Send reset
                        </button>
                        <button type="button" title="Delete account" disabled={u.id === me?.id}
                                onClick={() => window.confirm(`Delete ${u.email}? This can't be undone.`)
                                    && act(deleteUser(u.id), `${u.email} deleted`, reload)}
                                className="rounded-lg bg-white/[0.07] px-2.5 py-1.5 text-[11.5px] text-white/50 transition hover:bg-apple-red/20 hover:text-apple-red disabled:opacity-30">
                            <i className="fa-regular fa-trash-can"/>
                        </button>
                    </span>
                )}
            />
        </div>
    );
}
